import { useMutation, useQuery } from "@tanstack/react-query";

import {
  getTutorial,
  getTutorials,
  likeTutorial,
} from "@Http/lender_tutorials";
import { HttpQuery } from "@Types/http";
import { MutationError } from "@Types/index";
import { LenderTutorial } from "@Types/lender_tutorials";

import { queryClient } from "../App";

const useGetTutorials = (query?: HttpQuery) => {
  const queryKey = ["tutorials", query ?? []];

  const { data, isLoading, error } = useQuery<
    LenderTutorial[],
    MutationError,
    LenderTutorial[]
  >({
    queryKey: queryKey,
    queryFn: getTutorials(query),
  });

  return {
    data,
    isLoading,
    error,
  };
};
export const useGetTutorial = (id: string) => {
  const queryKey = [`tutorial-${id}`];

  const {
    data: blog,
    isLoading,
    error,
    isSuccess,
  } = useQuery({
    queryKey: queryKey,
    queryFn: getTutorial(id),
  });

  return {
    isSuccess,
    blog,
    isLoading,
    error,
  };
};

export const useLikeTutorial = (id: string) => {
  const mutation = useMutation<LenderTutorial, MutationError, { id: string }>(
    likeTutorial(id),
    {
      onSuccess: (data) => {
        queryClient.setQueriesData<LenderTutorial[]>(
          ["tutorials"],
          (oldData) => {
            return oldData?.map((tutorial) =>
              tutorial._id == data._id ? data : tutorial
            );
          }
        );

        queryClient.setQueryData<LenderTutorial>(
          [`tutorial-${id}`],
          () => data
        );
      },
    }
  );
  return {
    like: mutation.mutate,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};

export default useGetTutorials;
